import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoCalendarMixin from './KendoCalendarMixin'

export default {
    name: 'kendo-calendar',
    mixins: [ KendoCalendarMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoCalendar/index.js